import { ref, computed, nextTick } from 'vue';
import { FOCUS_EVENT, BLUR_EVENT, INPUT_EVENT, CHANGE_EVENT, CLICK_EVENT } from '../constants';
import { isDef } from '../validate';
import omit from '../omit';

function useInputModel(props, emit) {
  var inputRef = ref();
  var inputValue = computed(function () {
    return !isDef(props.modelValue) ? '' : String(props.modelValue);
  });
  // 判断是否开始新的合成输入
  var isComposing = ref(false);
  var inputProps = computed(function () {
    var mapInputProps = omit(props, ['size', 'showWordLimit', 'showArrow', 'modelValue', 'border']);
    var type = mapInputProps.type;
    if (type === 'number') {
      Object.assign(mapInputProps, {
        type: 'text',
        inputmode: 'decimal'
      });
    } else if (type === 'digit') {
      Object.assign(mapInputProps, {
        type: 'tel',
        inputmode: 'numeric'
      });
    }
    return mapInputProps;
  });
  function setInputValue() {
    var value = inputValue.value;
    if (inputRef && inputRef.value.value !== value) {
      inputRef.value.value = value;
    }
  }
  function blur() {
    if (inputRef.value) {
      inputRef.value.blur();
    }
  }
  function onFocus(e) {
    emit(FOCUS_EVENT, e);
    // ios10 readonly默认拉起键盘兼容
    if (props.readonly) {
      blur();
    }
  }
  function onBlur(e) {
    if (props.readonly) {
      return;
    }
    emit(BLUR_EVENT, e);
  }
  function onInput(e) {
    var value = e.target.value;
    if (isComposing.value) return;
    if (value === inputValue.value) {
      setInputValue();
      return;
    }
    emit(INPUT_EVENT, value);
    emit(CHANGE_EVENT, value);
    nextTick(function () {
      setInputValue();
    });
  }
  function onCompositionStart() {
    isComposing.value = true;
  }
  function onCompositionEnd(e) {
    if (isComposing.value) {
      isComposing.value = false;
      onInput(e);
    }
  }
  function onClick(e) {
    emit(CLICK_EVENT, e);
  }
  return {
    inputRef: inputRef,
    isComposing: isComposing,
    inputValue: inputValue,
    inputProps: inputProps,
    effects: {
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: onClick,
      onInput: onInput,
      onCompositionStart: onCompositionStart,
      onCompositionEnd: onCompositionEnd,
      setInputValue: setInputValue
    }
  };
}

export { useInputModel };
